import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import Select from '../Select';

const values = [
    'no_reason',
    'language',
    'gender_age',
    'smoker_nonsmoker',
    'availability',
    'drivers_license',
    'experience',
    'price',
    'red_dot',
];

const RejectionReasonSelect = ({ name, label, disabled, fullWidth }) => {
    const { t } = useTranslation();
    const options = useMemo(
        () =>
            values.map((value) => ({
                value,
                label: t(`rejectionReason.${value}`),
            })),
        [t]
    );
    return (
        <Select
            name={name}
            label={label}
            options={options}
            fullWidth={fullWidth}
            disabled={disabled}
            allowEmpty
        />
    );
};

RejectionReasonSelect.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
};

RejectionReasonSelect.defaultProps = {
    label: null,
    disabled: false,
    fullWidth: true,
};

export default RejectionReasonSelect;
